module.exports = __webpack_public_path__ + "static/media/darck.df4daad0.jpg";